<template>
    <div class="infoengine">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-5 filter-title-section">
                    <h2>Work Type Factor</h2>
                </div>
                <div class="col-md-7 text-right">
                    <div class="row">
                        <div class="col-md-6">
                            <base-search
                                placeholder="Search work type"
                                @keyword="getKeyword"
                            ></base-search>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                                        @click="apply"
                                    >
                                        <span class="btn-text">Apply</span>
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <div class="col-md-8">
                                    <b-button
                                        type="button"
                                        variant="secondary"
                                        class="secondary-add-btn"
                                        @click="$bvModal.show('add-work-popup')"
                                    >
                                        <span class="btn-text"
                                            >+ Add Work Type</span
                                        >
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'mobile-table-responsive-md',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="data" :fields="fields">
                <template slot="status" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-work-popup')
                            "
                        ></base-action>
                        <!-- if action archive -->
                        <base-action
                            :icon="
                                data.value == 'active'
                                    ? 'icon-trash'
                                    : 'icon-done'
                            "
                            :label="
                                data.value == 'active' ? 'Archive' : 'Activate'
                            "
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('status-update-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <!-- Get list records -->
        <base-records
            path="configurations/work-types"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>
        <!-- Add work popup -->
        <add-work-popup
            :title="title"
            :button-text="buttonText"
        ></add-work-popup>
        <!-- Archive popup -->
        <archive-popup
            title="Archive Work Type Factor"
            description="Are you sure you want to archive this work type factor? You can re-activate it later."
        ></archive-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import addWorkPopup from '@/components/popups/AddWorkPopup.vue'
import archivePopup from '@/components/popups/ArchivePopup.vue'

export default {
    components: {
        archivePopup,
        addWorkPopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'code',
                    label: 'Work Type Code',
                    sortable: true,
                    class: 'w-200px text-center',
                },
                {
                    key: 'title',
                    label: 'Work Type Title',
                    sortable: true,
                    formatter: (value) => {
                        return _.startCase(value)
                    },
                },
                {
                    key: 'status',
                    label: 'ACTION',
                    class: 'two-list',
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'code',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
            title: '',
            buttonText: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
